<template>
  <inv-strat-review-welcome-container></inv-strat-review-welcome-container>
</template>

<script>
import InvStratReviewWelcomeContainer from '@/app/modules/toolkit/inv-strat-review/modules/welcome/containers/inv-strat-review-welcome-container/inv-strat-review-welcome-container.vue';

export default {
  name: 'toolkit-inv-strat-review-welcome',
  components: {
    InvStratReviewWelcomeContainer,
  },
};
</script>
